import type * as Api from 'Api'

export const paymentErrorHandbook: Api.ErrorsHandbook<'default' | 'payment'> = {
  default: [],
  payment: [
    {
      status: 1,
      code: 404,
      message: 'Заказ или способ оплаты не найдены',
    },
  ],
}
